export enum InterestsEnum {
	AcroYoga = 'adf4d337-8383-499f-a949-86d7afb19348',
	Aerial = 'a42315c6-aa4d-4700-bed0-48625d5a86c3',
	Barre = '27c51a1a-9d7b-4f4e-a16d-7b50d9503d38',
	Boxing = '588b821d-ac59-4506-8bc6-c7b474e63abe',
	Calisthenics = 'dc4ddebd-a86d-42de-95ae-0684fc325cac',
	Food = '171533be-d06b-43d1-871e-2885cfbcfef4',
	Football = '88bf6eb6-b31a-4284-969c-4c9b3f1043d2',
	Golf = '44010557-caf8-4c6b-a5f6-a672c1e6e968',
	MartialArts = '668ec14d-76a8-4a58-8eb5-3fabc329a60d',
	MTBTrailRide = 'f70eb716-5efe-4e10-8c6e-9943431405b4',
	MTBTrailRiding = '225bde8b-eef5-4a58-a96d-25a2e340bc93',
	PaddleBoarding = '5c26c8bb-d609-4573-94a9-281b300ce252',
	Pickleball = '112e069e-42f8-4212-952b-5db7ac3bcc5e',
	Pilates = '22413b2f-e60e-4b97-9b58-f33efb8ae8c8',
	QiGong = '9d2d907f-da76-4e8b-b5c1-f80819631bd9',
	RollerSkating = '16e99b64-73f3-4bda-8499-3e94709200d2',
	ShuffleDance = '8d959d4e-8264-4b60-9b77-ca536bab93a4',
	SkateBoarding = 'b4d74369-bcaf-4284-a611-87353183d85a',
	Skiing = '6f75eb23-20f7-4c1c-a5e3-2bf54404755a',
	Soccer = '0d78af9b-4b91-4f9c-a333-8dd3d1280dac',
	Social = '8bc9a4b0-4ff8-429f-9d8f-7f97175937b8',
	Surfing = '1118b706-c666-42c0-91f3-14a392932ec9',
	Volleyball = 'e578f113-7ce1-4356-ab9b-fcf469ca6b7b',
	ObstacleRacing = 'c7d28d87-10e0-4c20-b874-298a9ee90b93',
	Yoga = 'ffc3f8e8-ee23-4839-b77a-f816af18b60e',
	RockClimbing = '70b28ac0-0656-4d20-9498-58363b0c5394',
	Running = '7256f3a5-4839-414c-b447-cb6b90244c7d',
	Hiking = 'd8c78010-b161-453a-b11d-5c11a27b16c2',
	Lifting = '0b553d88-b4d3-45fa-aa1b-020c4862b0ff',
	CrossFit = '849ebb6b-d786-484a-bc9b-1478822de079',
	Tennis = 'c3ee6bae-4f76-41d2-9d7c-2f2c03634fbf',
	Swimming = '5935c97e-01ba-48fd-9587-2d720b4dd8e4',
	Cycling = '53d78235-ef71-46b2-a195-d5989b036f37',
	Basketball = 'cb90ea0f-59b2-4f16-b491-b5e49a80714c',
	Walking = 'e820d92c-c5ce-4c36-bfde-7355f03e3f4a',
	HIIT = 'ea60eb82-c3dd-4bfa-9cea-ab623d809700',
	Dance = '747609cb-c062-4dbd-8c6e-705b8ba60aea',
	Breathwork = '1fd4cad7-ea01-4c96-bde1-2b86815105d8',
	Meditation = '4e60840d-5d8c-4b5d-97cf-2e409c9e06e8',
	Icebath = '5f269b75-9b1a-46cb-a522-77ef4a2395d5',
	Soundbath = '4a0349b1-b13a-4445-be92-b7e8a4b95d57',
	IndoorCycling = '134f11cf-4d54-4793-b4a6-bf01343fd787',
	Camping = '08046cfe-04f7-419d-a000-d53e2792b4d5',
	DogFriendly = 'dbea6796-71ad-4d80-a097-94d37f0d78d0',
	Outdoor = 'ad62993d-1c65-442a-b87d-fa66f134c0ee',
	LadiesOnly = '3d024a3c-0e9a-4949-8ae2-d8aad02607d7',
	YoungProfessionals = 'd4eaf499-1b05-41d4-8d93-d6d66ee335c9',
	GenZ = 'c9853d94-ce3a-4852-924a-f9c96228da02',
	Moms = 'ac53a546-9442-42ec-acfa-e73c7229289d',
	LGBTQPlus = '36d92590-6c8a-4e89-83f2-4fb693e79162',
	Water = 'e9939a71-5125-4922-b815-17d5d516391b',
	KidFriendly = '4812258b-4321-48cb-99aa-f75cd664d0c9',
	Spikeball = '3f0b1a7d-cb26-49d6-aadd-7157ce168ce2',
	Rowing = '847ce655-a503-48ae-9cd5-4b1c836292fc',

	Others = '581ea141-9b32-4051-952c-fcbc7dd749f5',
}
